<template>
  <div class="page_">
    <!-- 基础信息 -->
    <div class="notice_">
      <div class="tit_">
        <span class="fw_">{{$t('personalInfo[0]')||'基础信息'}}</span>
        <span class="modify_" @click="updateUserInfo('base')" v-if="baseModify">{{$t('claimStep[3]')||'完成'}}</span>
        <img class="modify_" src="../assets/medilinkPC/edit.svg" alt="" @click="changeInfo('base')" v-else>
      </div>
      <a-row type="flex" align="middle" style="margin-bottom: 10px;">
        <a-col :span="6">
          {{$t('personalInfo[2]')||'姓名'}}：
          <a-input :placeholder="$t('personalInfo[2]')||'请填写姓名'"   v-model="personInfo.name" style="width: 70%;" v-if="baseModify&&personInfo.isUpdateInfo==='0'" :readonly="personInfo.isUpdateInfo==='0'? false : 'readonly'"></a-input>
          <span v-else>{{personInfo.name}}</span>
        </a-col>
        <a-col :span="6">
          {{$t('personalInfo[3]')||'性别'}}：
          <span>{{personInfo.sexName}}</span>
        </a-col>
        <a-col :span="6">
          {{$t('personalInfo[5]')||'国籍'}}：
          <a-input :placeholder="$t('personalInfo[6]')||'请填写国籍'" v-model="personInfo.country" style="width: 70%;" v-if="baseModify"></a-input :readonly="personInfo.isUpdateInfo==='0'? false : 'readonly'">
          <span v-else>{{personInfo.country}}</span>
        </a-col>
      </a-row>
      <a-row type="flex" align="middle">
        <a-col :span="6">
          {{$t('personalInfo[7]')||'职业类别'}}:
          <a-input :placeholder="$t('personalInfo[8]')||'请填写职业类别'"  v-model="personInfo.occupation" style="width:63%;" v-if="baseModify"></a-input>
          <span v-else>{{personInfo.occupation}}</span>
        </a-col>
        <a-col :span="6">
          {{$t('personalInfo[9]')||'电子邮箱'}}:
          <a-input :placeholder="$t('personalInfo[10]')||'请填写电子邮箱'"  v-model="personInfo.email" style="width: 65%;" v-if="baseModify"></a-input>
          <span v-else>{{personInfo.email}}</span>
        </a-col>
        <a-col :span="6">
          {{$t('personalInfo[11]')||'手机号'}}:
          <a-input :placeholder="$t('personalInfo[12]')||'请填写手机号'" v-model="personInfo.phone" style="width: 68%;" v-if="baseModify"></a-input>
          <span v-else>{{personInfo.phone}}</span>
        </a-col>
      </a-row>
    </div>
    <!-- 会员卡信息 -->
    <div class="notice_">
      <div class="tit_">
        <span class="fw_">{{$t('personalInfo[0]')||'会员卡信息'}}</span>
        <a-button shape="round" icon="download" class="ml10" size="small" type="primary" @click="handleDownload">下载</a-button>
      </div>
      <a-row type="flex" align="middle" style="margin-bottom: 10px;">
        <a-col :span="8">
          <ecard :formData="cardInfo" ref="ecard"/>
        </a-col>
      </a-row>
    </div>
    <!-- 地址信息 -->
    <div class="notice_">
      <div class="tit_">
        <span class="fw_">{{$t('personalInfo[13]')||'地址信息'}}</span>
        <span class="modify_" @click="updateUserInfo('address')" v-if="addressModify">{{$t('claimStep[3]')||'完成'}}</span>
        <img class="modify_" src="../assets/medilinkPC/edit.svg" alt="" @click="changeInfo('address')" v-else>
      </div>
      <div>
        <template v-if="addressModify">
          {{$t('personalInfo[14]')||'省'}}：
          <a-select showSearch style="border: 1px solid #eee; width: 12%;border-radius:4px;" @change="change($event,'provice')" :value="addressFormData.provice">
            <a-select-option v-for="item in options" :key="item.code" :value="item.name">
              {{item.name}}
            </a-select-option>
          </a-select>
          {{$t('personalInfo[15]')||'市'}}：
          <a-select showSearch style="border: 1px solid #eee; width: 12%;border-radius:4px;" @change="change($event,'city')" :value="addressFormData.city">
            <a-select-option v-for="item in cityOptions" :value="item.name" :key="item.code">
              {{item.name}}
            </a-select-option>
          </a-select>
          {{$t('personalInfo[16]')||'区'}}：
          <a-select showSearch style="border: 1px solid #eee; width: 12%;border-radius:4px;" @change="change($event,'area')" :value="addressFormData.area">
            <a-select-option v-for="item in areaOptions" :value="item.name" :key="item.code">
              {{item.name}}
            </a-select-option>
          </a-select>
        </template>
        <!-- <a-input placeholder="请填写常住地" class="mr_" v-model="personInfo.area" v-if="addressModify" style="width: 150px;"></a-input> -->
        <span class="mr_" v-else style="margin-right:70px;">{{$t('personalInfo[48]')||'常住地址'}}：{{addressFormData.provice}} {{addressFormData.city}} {{addressFormData.area}}</span>
        <span class="mr_" v-if="!addressModify">{{addressFormData.address}}</span>
        <br>
        <span v-if="addressModify" style="margin-top:15px;">{{$t('personalInfo[17]')||'详细地址'}}：</span>
        <a-input :placeholder="$t('personalInfo[18]')||'请填写详细地址'" class="mr_" v-model="addressFormData.address" v-if="addressModify" style="width:50%;margin-top:15px;"></a-input>
        
      </div>
    </div>
    <!-- 证件信息 -->
    <div class="notice_">
      <div class="tit_">
        <span class="fw_">{{$t('personalInfo[19]')||'证件信息'}}</span>
        <span class="modify_" @click="updateUserInfo('card')" v-if="cardModify&&personInfo.isUpdateInfo==='0'">{{$t('claimStep[3]')||'完成'}}</span>
        <img class="modify_" src="../assets/medilinkPC/edit.svg" alt="" @click="changeInfo('card')" v-if="personInfo.isUpdateInfo==='0'">
      </div>
      <div>
        {{$t('personalInfo[20]')||'证件类型'}}：
        <a-select v-model="personInfo.idType" class="mr_" v-if="cardModify" style="width: 15%;border: 1px solid #E7E7E7;border-radius:4px;" :disabled="personInfo.isUpdateInfo==='1'?true:false">
          <a-select-option value="身份证">{{$t('personalInfo[21]')||'身份证'}}</a-select-option>
          <a-select-option value="护照">{{$t('personalInfo[22]')||'护照'}}</a-select-option>
          <a-select-option value="其他">{{$t('personalInfo[23]')||'其他'}}</a-select-option>
        </a-select>
        <span class="mr_" v-else style="margin-right:70px;">{{personInfo.idType | filterID(IdOptions,$i18n.locale)}}</span>
        {{$t('personalInfo[24]')||'证件号码'}}：
        <a-input :placeholder="$t('personalInfo[25]')||'请填写证件号码'" class="mr_" 
        :class="{gray_:personInfo.isUpdateInfo==='1'}"
        v-model="personInfo.idNumber" v-if="cardModify" style="width: 15%" :readonly="personInfo.isUpdateInfo==='0'? false : 'readonly'"></a-input>
        <span class="mr_" v-else style="margin-right:70px;">{{personInfo.idNumber}}</span>
        {{$t('personalInfo[26]')||'证件有效期'}}：
        <a-date-picker :disabled="timeDisabled" :showToday="false" @change="idValidDateChange" :placeholder="$t('personalInfo[27]')||'请选择证件有效期'" v-if="cardModify&&personInfo.isUpdateInfo==='0'" :disabledDate="disabledDate" class="mr_ date_" v-model="personInfo.idValidDate" style="border: 0;width:16%;border-radius:4px;"></a-date-picker>
        <span class="mr_" v-else style="margin-right:70px;">{{personInfo.idValidDate}}</span>
        <span :class="{ long_time_ : cardModify }"v-if="personInfo.idValidDate&&personInfo.idValidDate=='9999-12-31'">
          <a-checkbox v-model="longTime" :disabled="personInfo.isUpdateInfo==='0'?disabled:true" @change="longTimeChange"> {{$i18n.locale == 'zh-cn' ?'长期':'Long-term'}}</a-checkbox>
        </span>
        <span class="mr_">{{$t('personalInfo[28]')||'证件照片'}}：
          <span class="blue_c"  v-if="personInfo.idCardImgFlag == 1 && idValidDate">{{ $t('personalInfo[29]')||'已上传'}}</span>
          <span v-else class="blue_c" @click="uploadTag=true">
            {{ personInfo.idCardImgFlag == 1 && !idValidDate ? $t("cardUpload.unDate"):$t("cardUpload.upload")}}
          </span>
        </span>
      </div>
    </div>
    <div class="card_" style=" padding: 27px 29px 10px;">
        <div class="tit_ fw_">{{$t('claim[19]')||'银行卡信息'}}</div>
        <p style="margin-bottom:0;color:#bbb;font-size:13px;display:flex;align-items:center;"><span class="icon_info"></span>{{$i18n.locale == 'zh-cn' ?'信用卡、存折、海外个人账户无法用于理赔的支付，请添加您的银行储蓄卡':'Credit cards, passbooks, and overseas personal accounts cannot be used to settle claims. Please add your bank savings card.'}}</p>
        <div class="box_">
          <div class="item_ item_bank" v-for='(item,index) in BXcardList' style="padding:10px 2px;border-bottom:1px solid #E7E7E7">
            <div class="account_" @click="extendTable('main',index)" style="font-weight:bold;">
              <span class="arrow_" :class="{arrow_t: item.isShowBankListTable}" >
                <span class="fw_">{{$t('claim[20]')||'理赔款账户'}}：</span>
                <span>{{item.ylExt1}} {{item.ylCardno}}</span>
              </span>
            </div>
            <p v-if="item.bankList&&item.bankList.length>0&&item.bankList.filter(item1=>item1.isMainCard == '0').length>0" style="padding:0 0 0 16px;font-weight:bold;">{{$t('bankInfo[5]')}}:{{item.bankList.filter(item1=>item1.isMainCard == '0')[0].bankaccnm}}&nbsp;{{item.bankList.filter(item1=>item1.isMainCard == '0')[0].bankdetail?item.bankList.filter(item1=>item1.isMainCard == '0')[0].bankdetail:item.bankList.filter(item1=>item1.isMainCard == '0')[0].banknm}}&nbsp;{{item.bankList.filter(item1=>item1.isMainCard == '0')[0].bankaccno | filterBankNo()}} </p>
            <a-table v-if="item.isShowBankListTable" :columns="columns"
                    :data-source="item.bankList"
                    size="small"
                    :pagination="false">
                    <template slot="banknm" slot-scope="record">
                      <span>{{record.banknm}}</span><span v-if="record.isMainCard == '0'" class="blue_f">[{{$t('claim[21]')||'主卡'}}]</span>
                    </template>
                    <template slot="bankaccno" slot-scope="record">
                      <span>{{record.bankaccno | filterBankNo()  }}</span>
                    </template>
                    
                    <template slot="bankdetail" slot-scope="record">
                       <span>{{record.currency=='USD'? record.bankAddress ? record.countryName+record.bankAddress : record.countryName : record.bankDetail}}</span>
                    </template>
                    <template slot="do"
                              slot-scope="record">
                      <a @click="unlock(record.empId,index)" v-if="record.isMainCard == '0'" class="hover_bold" >{{$t('claim[22]')||'解除主卡'}}</a>
                      <a @click="setMainCard(record.empId,index)" class="hover_bold" v-if="record.isMainCard == '1'">{{$t('claim[24]')||'设为主卡'}}</a>
                      <a style="margin-left: 20px;color:#999999;" class="del_btn" @click="() => deleteBankCardInfo(record.empId,record.memberControlNo)">{{$t('claim[23]')||'删除'}}</a>
                    </template>
            </a-table>
            <div class="add_" v-if="item.isShowBankListTable">
              <span class="card_info" :class="{bold_:item.isAddCard}">{{$t('claim[25]')||'添加银行卡信息'}}</span>
              <a-switch 
                        @change="onChange($event,'main',index)"
                        :checked-children="$t('claim[26]')||'开'"
                        :un-checked-children="$t('claim[27]')||'关'" /><br>
              <p style="margin-bottom:0;color:#bbb;font-size:13px;display:flex;align-items:center;padding:15px 0;" v-if="item.isAddCard"><span class="icon_info"></span>{{$t('claim[28]')||'请添加本人名下银行卡，请确保姓名、证件号码和银行卡号与银行预留信息完全一致。'}}</p>
              <div class="modify_info" v-if="item.isAddCard&&item.isShowBankListTable" :class="{long:$i18n.locale != 'zh-cn'}">
                <div class="item">
                  <span class="mr_">{{$t('claim[29]')||'户名'}}</span>
                  <a-input :placeholder="$t('claim[30]')||'请填写户名'" style="width: 66%;" v-model="formData.name"></a-input>
                </div>
                <div class="item">
                  <span class="mr_">{{$t('claim[31]')||'证件号码'}}</span>
                  <a-input :placeholder="$t('claim[32]')||'请填写证件号码'" style="width: 66%;" v-model="formData.idNumber"></a-input>
                </div>
                <div class="item">
                  <span class="mr_">{{$t('claim[61]')||'银行币种'}}</span>
                  <a-select style="width: 66%;border:1px solid #d9d9d9;" v-model="formData.currency" :placeholder="$t('claim[62]')||'请选择银行币种'" @change="changeCurrency">
                    <a-select-option v-for="item in currencyOptions" :key="item.value" :value="item.value">{{item.name}}</a-select-option>
                  </a-select>
                </div>
                <div class="item">
                  <span class="mr_">{{$t('claim[33]')||'银行卡号'}}</span>
                  <a-input :placeholder="$t('claim[34]')||'请填写银行卡号'" style="width: 66%;" v-model="formData.bankNo"></a-input>
                </div>
                <template v-if="formData.currency == 'USD'">
                  <div class="item">
                    <span class="mr_">{{$t('claim[35]')||'银行名称'}}</span>
                    <a-input :placeholder="$t('bankInfo[8]')||'请填写银行名称'"
                          style="width: 66%;" v-model="formData.bankName" :title="formData.bankName"></a-input>
                  </div>
                  <div class="item">
                    <span class="mr_">{{$t('bankInfo[22]')||'银行所在国家'}}</span>
                      <a-select
                        mode="default"
                        label-in-value
                        :value="countryCode"
                        show-search
                        :placeholder="$t('bankInfo[18]')||'请选择银行所在国家'"
                        style="width: 66%;border: 1px solid #E7E7E7 !important;border-radius:4px;"
                        :default-active-first-option="false"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @search="handleSearch($event,'country')"
                        @change="handleSelectChange($event,'country')"
                      >
                        <a-select-option v-for="d in countryData" :key="d.countryCode" :value="d.countryCode">{{ $i18n.locale == 'zh-cn' ? d.countryName : d.countryEnName }}</a-select-option>
                      </a-select>
                  </div>
                  <div class="item">
                    <span class="mr_">{{$t('claim[63]')||'银行汇款代码'}}</span>
                    <a-input :placeholder="$t('claim[64]')||'请输入银行汇款代码'"
                          style="width: 66%;" v-model="formData.swiftCode"></a-input>
                  </div>
                  <div class="item">
                    <span class="mr_">{{$t('claim[36]')||'银行所在地'}}</span>
                    <a-input :placeholder="$t('bankInfo[21]')||'请输入银行所在地'"
                          style="width: 66%;" v-model="formData.bankAddress"></a-input>
                  </div>
                  <div class="item"></div>
                </template>
                <template v-else>
                  <div class="item">
                    <span class="mr_">{{$t('claim[35]')||'银行名称'}}</span>
                    <a-select
                      mode="default"
                      label-in-value
                      :value="bankValue"
                      :placeholder="$t('personalInfo[31]')||'请选择银行名称'"
                      style="width: 66%;border: 1px solid #E7E7E7;border-radius:4px;"
                      :filter-option="false"
                      :not-found-content="fetching ? undefined : null"
                      @search="fetch($event,'name')"
                      @change="bankChange($event,'main')"
                      showSearch
                    >
                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                      <a-select-option v-for="d in bankCardInfoList" :key="d.RefCd" :value="d.RefCd">
                        {{ d.Fdesc }}
                      </a-select-option>
                    </a-select>
                  </div>
                  <div class="item">
                    <span class="mr_" style="white-space:nowrap;">{{$t('claim[36]')||'银行所在地'}}</span>
                    <a-select
                     mode="default"
                      label-in-value
                      :autoClearSearchValue="false"
                      optionLabelProp='children'
                      :value="addressValue"
                    :placeholder="$t('personalInfo[32]')||'请选择银行所在地'"
                      style="width: 66%;border: 1px solid #E7E7E7;border-radius:4px;"
                      :filter-option="true"
                      :not-found-content="null"
                      @search="fetch($event,'address')"
                      @change="addressChange($event,'main')"
                      showSearch
                    >
                    <!-- <a-spin v-if="fetching" slot="notFoundContent" size="small" /> -->
                      <a-select-option v-for="d in areaInfoList" :key="d.refCd" :value="d.refCd">
                        {{ $i18n.locale == 'zh-cn' ? d.fdesc : d.sdesc }}
                      </a-select-option>
                    </a-select>
                  </div>
                  <div v-if="formData.currency == 'RMB'" class="item">
                    <span class="mr_">{{$t('claim[37]')||'银行支行'}}</span>
                    <a-select
                      mode="default"
                      label-in-value
                      :autoClearSearchValue="false"
                      optionLabelProp='children'
                      :value="branchValue"
                      :placeholder="$t('personalInfo[33]')||'请选择银行支行名称'"
                      style="width: 66%;border: 1px solid #E7E7E7;border-radius:4px;"
                      :filter-option="true"
                      :not-found-content="null"
                      @search="fetch($event,'branch')"
                      @change="branchChange($event,'main')"
                      showSearch
                    >
                      <a-select-option v-for="d in searchBranchBankList" :key="d.RefCd" :value="d.Fdesc">
                        {{ d.Fdesc }}
                      </a-select-option>
                    </a-select>
                  </div>
                </template>
              </div>
            </div>
            <a-button type="primary" v-if="item.isAddCard&&item.isShowBankListTable" @click="saveBankInfo('main',item.ylMemberNo)" style="width:90px;border-radius:2px;">{{$t('InsuranceInfo[14]')||'保存'}}</a-button>
            <a-button style="margin-left: 10px;width:90px;border-radius:2px;" v-if="item.isAddCard&&item.isShowBankListTable" @click="cancel">{{$t('InsuranceInfo[15]')||'取消'}}</a-button>
          </div>
        </div>
      </div>
      <a-modal  :footer="null" class="modal_ blue_" width="500px" v-model="uploadTag">
        <div class="top_">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" :tab="$t('cardUpload.tit1')">
              <a-select v-model="uploadType" style="border: 1px solid #E7E7E7;border-radius:4px;width:150px;margin-left:30px;" >
                <a-select-option value="00" key="00">
                      {{$t('cardUpload.type1') }}
                </a-select-option>
                <a-select-option value="01" key="01">
                      {{$t('cardUpload.type2') }}
                </a-select-option>
                <a-select-option value="08" key="08">
                      {{$t('cardUpload.type3') }}
                </a-select-option>
              </a-select>
              <div class="upload_" v-if="uploadType=='00'">
                <div class="upload_c" >
                  <img :src="imgUrl?imgUrl:require('../assets/medilinkPC/upload2.png')" alt="">
                  <span>{{$t('cardUpload.upload1')}}</span>
                  <input @change="uploadPhoto($event,'1')" type="file" class="kyc-passin" style="opacity: 0;" title="" />
                </div>
                <div class="upload_c">
                  <img :src="imgUrl1?imgUrl1:require('../assets/medilinkPC/upload2.png')" alt="">
                  <span>{{$t('cardUpload.upload2')}}</span>
                  <input @change="uploadPhoto($event,'2')" type="file" class="kyc-passin" style="opacity: 0;" title="" />
                </div>
              </div>
              <div class="upload_" v-else-if="uploadType=='01'">
                <div class="upload_c" >
                  <img :src="imgUrl2?imgUrl2:require('../assets/medilinkPC/upload2.png')" alt="">
                  <span>{{$t('cardUpload.upload3')}}</span>
                  <input @change="uploadPhoto($event,'3')" type="file" class="kyc-passin" style="opacity: 0;" title="" />
                </div>
              </div>
              <div class="upload_" v-else>
                <div class="upload_c" >
                  <img :src="imgUrl3?imgUrl3:require('../assets/medilinkPC/upload2.png')" alt="">
                  <span>{{$t('cardUpload.upload1')}}</span>
                  <input @change="uploadPhoto($event,'081')" type="file" class="kyc-passin" style="opacity: 0;" title="" />
                </div>
                <div class="upload_c">
                  <img :src="imgUrl4?imgUrl4:require('../assets/medilinkPC/upload2.png')" alt="">
                  <span>{{$t('cardUpload.upload2')}}</span>
                  <input @change="uploadPhoto($event,'082')" type="file" class="kyc-passin" style="opacity: 0;" title="" />
                </div>
              </div>
              <a-button type="primary" style="display:block;margin:30px auto 0;" @click="submitPhoto"> {{ $i18n.locale == 'zh-cn' ? '提交' : 'Submit' }}</a-button>
            </a-tab-pane>
            <a-tab-pane key="2" :tab="$t('cardUpload.tit2')">
              <div class="item_u">
                <label for="">{{$t('personalInfo[20]')||'证件类型'}}:</label>
                <a-select v-model="userIdType" style="border: 1px solid #E7E7E7;border-radius:4px;width:200px;" >
                  <a-select-option value="00" key="00">
                        {{$t('cardUpload.type1') }}
                  </a-select-option>
                  <a-select-option value="01" key="01">
                        {{$t('cardUpload.type2') }}
                  </a-select-option>
                  <a-select-option value="08" key="08">
                        {{$t('cardUpload.type3') }}
                  </a-select-option>
                </a-select>
              </div>
              <div class="item_u">
                <label>{{$t('personalInfo[2]')||'姓名'}}:</label>
                <a-input :placeholder="$t('alertPrompt[23]')" v-model="userName" style="width:200px;"></a-input>
              </div>
              <div class="item_u">
                <label>{{$t('personalInfo[24]')||'证件号码'}}:</label>
                <a-input :placeholder="$t('alertPrompt[28]')" v-model="userIdCardNumber" style="width:200px;"></a-input>
              </div>
              <div class="item_u">
                <label>{{$t('personalInfo[26]')||'证件有效期'}}:</label>
                 <a-date-picker :disabled="ifLong==false?false:true" :disabledDate="disabledDate" :showToday="false" @change="userDateChange" :placeholder="$t('personalInfo[27]')||'请选择证件有效期'"   style="border: 1px solid #E7E7E7;width:200px;border-radius:4px;" class="date_user"></a-date-picker>
                <a-checkbox v-model="ifLong"  @change="ifLongChange" style="margin-left:30px;margin-top:5px;position:relative;white-space:nowrap;"> {{$i18n.locale == 'zh-cn' ?'长期':'Long-term'}}</a-checkbox>
              </div>
              <a-button type="primary" style="display:block;margin:30px auto 0;" @click="submitInfo"> {{ $i18n.locale == 'zh-cn' ? '提交' : 'Submit' }}</a-button>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-modal>
  </div>
</template>



<script>
import api from "@/utils/api"
import debounce from 'lodash/debounce'
import moment from "moment";
import ecard from './components/ecard'
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park',
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
  },
];
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  data() {
    this.lastFetchId = 0;
    this.fetch = debounce(this.fetch, 0)
    return {
      previewVisible: false,
      previewImage: '',
      fileList: [
        {
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        },
      ],
      data,
      columns:[
        {
          title: this.$t('bankInfo[0]'),
          // dataIndex: 'banknm',
          scopedSlots: { customRender: 'banknm'}
        },
        {
          title: this.$t('bankInfo[6]') || '银行所在国家/地区',
          scopedSlots: { customRender: 'bankdetail'}
        },
        {
          title: this.$t('bankInfo[2]'),
          scopedSlots: { customRender: 'bankaccno'}
        }, 
        {
          title: this.$t('bankInfo[4]'),
          dataIndex: 'bankaccnm',
        },
        {
          title: this.$t('bankInfo[3]'),
          scopedSlots: { customRender: 'do' },
        },
      ],
      baseImg: '',
      visible: false,
      current: 0,
      stepStyle: {
        marginBottom: '60px',
        boxShadow: '0px -1px 0 0 #e8e8e8 inset',
      },
      // steps,
      data,
      remark: '',
      stepActive: 1,
      baseInfo: {},
      relationWithInsuredList: [
        {
          value: '1',
          text: this.$t('relationship[0]')
        },
        {
          value: '2',
          text: this.$t('relationship[1]')
        },
        {
          value: '3',
          text: this.$t('relationship[2]')
        }
      ],
      currencyOptions: [
        {name: this.$t('bankInfo[15]') || '人民币', value: 'RMB'},
        {name: this.$t('bankInfo[16]') || '港币', value: 'HK$'},
        {name: this.$t('bankInfo[14]') || '美币', value: 'USD'},
      ],
      hospitalName: '',
      amount: '',
      isAddCard: false,
      isChildAddCard: false,
      bankList: [],
      mainCard: {},
      memberNo: '',
      cityCode: '',
      bankCd: '',
      bankCardInfoList: [],
      bankName: '',
      areaInfoList: [],
      area: '',
      branchBankInfoList: [],
      searchBranchBankList:[],
      branchName: '',
      formData: {
        name: '',
        idNumber: '',
        bankName: '',
        bankCode: '',
        city: '',
        citycode: '',
        bankNo: '',
        bankDetail: '',
        bankDailCode: '',
        memberNo: '',
        currency: undefined,
        swiftCode:'',
        bankAddress:'',
        countryName:''
      },
      childFormData: {
        name: '',
        idNumber: '',
        bankName: '',
        bankCode: '',
        city: '',
        citycode: '',
        bankNo: '',
        bankDetail: '',
        bankDailCode: '',
        memberNo: '',
        // fileList: []
      },
      uploadFileList: [],
      submitData: {},
      relative: '',
      date: '',
      coverage: '',
      personInfo: {},
      baseModify: false,
      addressModify: false,
      cardModify: false,
      isShowBankListTable: false,
      isShowTable: false,
      bankValue: [],
      childBankValue: [],
      addressValue: [],
      childAddressValue: [],
      branchValue: [],
      childBranchValue: [],
      fetching: false,
      fetchData: [],
      keyWord: '',
      language: 'CHINAESE',
      proIndex: '',
      cityIndex: '',
      areaIndex: '',
      options: [],  // 省市区数据
      cityOptions: [], // 市选项
      areaOptions: [], //区选项
      addressFormData: {
        address: "",
        provice: "",
        city: "",
        area: ""
      },
      ldCardInfoList: [],
      provinceValue: [],
      cityValue: [],
      areaValue: [],
      longTime: false, // 长期
      disabled: true,
      timeDisabled: false,
      IdOptions:[
        {
          text:'身份证',
          textEn:'ID card'
        },
        {
          text:'护照',
          textEn:'passport'
        },
        {
          text:'其他',
          textEn:'Other'
        },
      ],
      BXcardList:[],
      showUpload:false,
      uploadTag:false,
      uploadType:'00',
      cardFileList:[
      ],
      imgUrl:'',
      imgUrl1:'',
      imgUrl2:'',
      imgUrl3:'',
      imgUrl4:'',
      userName:'',
      userIdCardNumber:"",
      ifLong:false,
      userDate:null,
      userIdType:'00',
      countryData: [],
      countryCode: '',
      cardInfo: {}
    }
  },
  components: {
    ecard
  },
  filters:{
    filterID:(value,options,language)=>{
      if(value){
        if(language=='zh-cn'){
          return value
        }else{
          let name=''
          options.map(item=>{
            if(item.text==value){
              name= item.textEn
            }
          })
          return name
        }
      }else{
        return ''
      }
    },
    filterBankNo(val){
      if(!val || val.length<8){
        return val
      }else {
        let num=val.substring(0,val.length-4).length
        let str=""
        for(let i=0;i<num;i++){
          str=str+'*'
        }
        let newValue=str+val.substring(val.length-4,val.length)
        return newValue
      }
    }
  },
  computed: {
    idValidDate() {
      return (
        this.personInfo.idValidDate == "长期有效" ||
        (this.personInfo.idValidDate &&
          moment(this.personInfo.idValidDate) > moment())
      );
    }
  },
  mounted() {
    this.getBankInfoList()
    this.getCityInfo()
    this.getArea('provice')
    this.personCenterInfo()
    this.getcalimAppBaseIfo()
    this.formData.memberNo = localStorage.getItem('memberNo');
    this.getMemberInfo();
    let cardInfo = JSON.parse(localStorage.getItem('baseInfo'));
    let { Card_no, Employee_name, Corp_code, Corp_name, english_name} = cardInfo
    this.cardInfo = {
      ...cardInfo,
      cardNo: Card_no,
      employeeName: Employee_name,
      corpName: Corp_name,
      corpCode: Corp_code,
      empName: english_name
    }
  },
  methods: {
    moment,
    handleDownload() {
      this.$refs.ecard.handleDownloadSubmit()
    },
    // 筛选省市区的code
    valueToCode(arr, value) {
      let code = ''
      for(let i = 0; i < arr.length; i++) {
        if(arr[i].name == value) {
          code = arr[i].code
          break;
        }
      }
      return code;
    },
    handleSearch (value, type) {
      if (this.st) {
        clearTimeout(this.st);
        this.st = null;
      }
      this.st = setTimeout(() => {
        clearTimeout(this.st);
        this.st = null;
        this.getCountryList(value)
      }, 300);
    },
    handleSelectChange (value) {
      this.countryCode = value;
      this.formData.countryCode = value.key;
    },
    getCountryList (value) {
      let data = {
        keyWord: value,
      };
      api.getCountryList(data).then(res => res.data).then(data => {
        this.countryData = data.data;
      })
    },
    longTimeChange(e) {
      console.log('选择了长期',e)
      this.longTime = e.target.checked
      this.timeDisabled = false
      if (this.longTime) {
        this.timeDisabled = true
      }
    },
    cancel(type) {
      // 清空数据
        this.formData.name = ''
        this.formData.idNumber = ''
        this.formData.bankNo = ''
        this.bankValue = []
        this.addressValue = []
        this.branchValue = []
        this.formData.currency=undefined
        this.countryCode=undefined
        this.formData.countryValue={}
        this.formData.bankName=''
        this.formData.swiftCode=''
        this.formData.bankAddress=''
        this.formData.countryName=''
    },
    fetch(value,type) {
      console.log('fetching user', value,type);
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.fetchData = [];
      this.fetching = true;
      if (type == 'name') {
        this.bankName = value
        this.getBankInfoList()
      } else if (type == 'address') {
        this.area = value
        this.getCityInfo(value)
      } else if (type == 'branch') {
        this.branchName = value
        this.getBrachOfBankInfoList('branch',value)
      }
    },
    bankChange(value,type) {
      this.bankName = value.key
      if (type == 'main') {
        console.log('银行选取的是',value);
        this.formData.bankCode = value.key
        this.formData.bankName = value.label.replace(/\s+/g,"")
        Object.assign(this, {
          bankValue:value,
          fetchData: [],
          fetching: false,
        });
      } else {
        // 添加连带银行卡
        Object.assign(this, {
          childBankValue:value,
          fetchData: [],
          fetching: false,
        });
        this.childFormData.bankName = value.label
        this.childFormData.bankCode = value.key
        console.log('添加子银行卡',this.childFormData)
      }
    },

    addressChange(value,type) {
      this.addressValue=value
      this.area = value.key
      console.log('地址选取的是',value);
        this.formData.citycode = value.key
        this.formData.city=value.label
        this.formData.bankDetail=''
        this.formData.bankDailCode=''
        this.branchValue = []
        Object.assign(this, {
          addressValue:value,
          fetchData: [],
          fetching: false,
        });
       this.getBrachOfBankInfoList()
    },
    branchChange(value,type) {
      if (type == 'main') {
        if(this.branchBankInfoList.filter(item=>item.Fdesc==value.key).length>0){
          this.formData.bankDailCode = this.branchBankInfoList.filter(item=>item.Fdesc==value.key)[0].RefCd
        }else{
          this.formData.bankDailCode=''
        }
        this.formData.bankDetail = value.key
        Object.assign(this, {
          branchValue:value,
          fetchData: [],
          fetching: false,
        });
      } else {
        this.childFormData.bankDailCode = value.key
        this.childFormData.bankDetail = value.label
        Object.assign(this, {
          childBranchValue:value,
          fetchData: [],
          fetching: false,
        });
      }
    },
    extendTable(type,index) {
      if (type == 'main') {
        this.BXcardList[index].isShowBankListTable=!this.BXcardList[index].isShowBankListTable
        this.BXcardList.map((item,index1)=>{
          if(index1!=index){
            item.isShowBankListTable=false
          }
          item.isAddCard=false
          item.extendTable=false
        })
      } else {
        this.isShowTable = !this.isShowTable
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    idValidDateChange(date,dateString) {
      this.personInfo.idValidDate = dateString
      this.disabled = false
      if (dateString) {
        this.disabled = true
      }
    },
    async changeInfo(type) {
      if (type == 'base') {
        this.baseModify = true
      } else if (type == 'address') {
        this.addressModify = true
        this.addressFormData.provice && await this.getArea('city', this.valueToCode(this.options, this.addressFormData.provice))
        this.addressFormData.city && this.getArea('area', this.valueToCode(this.cityOptions, this.addressFormData.city))
      } else {
        this.cardModify = true
        this.disabled = false
      }
    },
    done() {

    },
    updateUserInfo(type) {
      let param = {}
      if (type == 'base') {
        this.baseModify = false
        param = this.personInfo
      } else if (type == 'address') {
        this.addressModify = false
        param = {
          ...this.addressFormData,
          address: this.addressFormData.address || this.personInfo.address
        }
      } else {
        this.cardModify = false
        this.disabled = true
        param = {
          ...this.personInfo
        }
        // 身份证  01  护照  08   其他 00
        // idNumber: "1231231231"
        // idType: "01"
        // name: "王五一"
        // sex: "F"
        // validDate: "9999-12-31"
        param = {
          ...this.personInfo,
          idValidate: this.longTime ? '9999-12-31' : this.personInfo.idValidDate
        }
      }
      api.updateUserInfo(param).then(res => {
          this.$message.success(res.data.msg)
          localStorage.setItem('baseInfo',JSON.stringify(param))
      })
    },
    baseChange() {
      this.baseModify = true
    },
    getcalimAppBaseIfo() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const cardNo = userInfo && userInfo.cardNo
      api.getcalimAppBaseIfo({applyType: "LPSQ"}).then(res => res.data).then(data => {
        data.data.policyList.forEach(item => {
          if (cardNo == item.cardNo) {
            this.baseInfo = item
          }
        })
      })
    },
    onChange(checked,type,index) {
      if (type == 'main') {
        this.BXcardList[index].isAddCard=!this.BXcardList[index].isAddCard
        if(this.BXcardList[index].isAddCard==checked){
          this.cancel()
        }
      } else {
        this.isChildAddCard = checked
      }
      console.log(`a-switch to ${checked}`);
    },
    bankCardInfo(memberNo) {
      this.memberNo = localStorage.getItem('memberNo')
      api.bankCardInfo({memberNo: memberNo}).then(res => res.data).then(data => {
        this.bankList = data.data
        this.mainCardInfo()
      })
    },
    getBankInfoList() {
      let param = {
        keyWord: this.bankName,
        language: this.language
      }      
      api.getBankInfoList(param).then(res => res.data).then(data => {
        console.log(data,'总行列表')
        this.bankCardInfoList = data.data
        this.fetching=false
      })
    },
    mainCardInfo() {
      // 确定主卡信息
      this.bankList.map(item => {
        if (item.isMainCard == 0) {
          this.mainCard = item
        }
      });
    },
    unlock(empId,index) {
      if(this.BXcardList[index].bankList.length<2){
        if(this.$i18n.locale == 'en-us'){
          this.$message.error('Currently there is only one bank card in the claim settlement account, and it is not allowed to untie')
        }else{
          this.$message.error('当前理赔款账户只有一张银行卡，不允许解绑')
        }
      }else{
        api.unbindbankCardInfo({id: empId}).then(res => res.data).then(data => {
          this.$message.success(data.msg)
          this.getMemberInfo()
        })
      }
    },
    deleteBankCardInfo(empId,memberNo) {
      api.deleteBankCardInfo({id: empId}).then(res => res.data).then(data => {
        // this.$message.success(data.msg)
        if(this.$i18n.locale == 'en-us'){
          this.$message.success('Successfully deleted')
        }else{
          this.$message.success('删除银行卡成功')
        }
        
        this.bankCardInfo(memberNo)
        this.getMemberInfo()
      })
    },
    changebankCardInfo(data,memberNo) {
      // 变更主领卡
      api.changebankCardInfo(data).then(res => {
        this.$message.success(res.data.msg);
        this.bankCardInfo(memberNo);
        this.getMemberInfo()
        // this.ifshow = false;
      });
    },
    setMainCard(newMainId,index) {
      // 设置为主卡
      let id=''
      if(this.BXcardList[index].bankList.filter(item=>item.isMainCard=='0').length>0){
        id=this.BXcardList[index].bankList.filter(item=>item.isMainCard=='0')[0].empId
      }
      let data = {
        newMainId: newMainId,
        oldMainId: id,
        language: this.language
      };
      this.changebankCardInfo(data,this.BXcardList[index].ylMemberNo);
    },
    getCityInfo(value) {
      let param = {
        level:"2",
        refGrp:"STATE_CHN",
        city: this.area,
        language:this.language
      }
      api.getAreaInfo(param).then(res => res.data).then(data => {
        this.areaInfoList = data.data
      })
    },
    getBrachOfBankInfoList(type,value) {
      if (type == 'branch') {
          let branchList = []
          this.searchBranchBankList=[]
          if(this.branchBankInfoList.length>0){
            this.branchBankInfoList.forEach(item => {
              if (item.Fdesc.indexOf(this.branchName) > -1) {
                branchList.push(item)
              }
            })
            if(branchList.length>0){
              this.searchBranchBankList = branchList
            }else{
              this.searchBranchBankList.push({RefCd:'',Fdesc:value}) 
            }
          }else{
            this.searchBranchBankList.push({RefCd:'',Fdesc:value}) 
          }
      } else {
        let param = {
          bankCd: this.bankName,
          cityCode: this.area
        }
        api.getBrachOfBankInfoList(param).then(res => res.data).then(data => {
          this.branchBankInfoList = data.data
          this.searchBranchBankList=data.data
          this.fetching=false
          console.log(data,'支行列表');
        })
      }
    },
    saveBankInfo(type,memberNo) {
      
      let param = {
        ...this.formData,
        memberNo: memberNo
      }
      if(!param.bankAddress){
        param.bankAddress=''
      }
      if (param.name == '') {
      if (this.$i18n.locale == 'zh-cn') {
        this.$message.error('姓名不能为空')
      }else{
        this.$message.error("The name can't be null")
      }
      return false
    } else if (param.idNumber == '') {
      if (this.$i18n.locale == 'zh-cn') {
        this.$message.error('证件号码不能为空')
      }else{
        this.$message.error("The Id number can't be null")
      }
      return false
    } else if (param.bankNo == '') {
      if (this.$i18n.locale == 'zh-cn') {
        this.$message.error('银行卡号码不能为空')
      }else{
        this.$message.error("The bank card number can't be null")
      }
      return false
    } else if (param.bankName=='') {
      if (this.$i18n.locale == 'zh-cn') {
        this.$message.error('银行名称不能为空')
      }else{
        this.$message.error("The bank name can't be null")
      }
      return false
    } else if (param.currency == 'RMB') {
      if (param.citycode == ''||param.city=='') {
        if (this.$i18n.locale == 'zh-cn') {
          this.$message.error('银行所在地不能为空')
        }else{
          this.$message.error("The bank address can't be null")
        }
        return false
      }
    } else if (param.currency == 'USD') {
      if (!param.countryCode) {
        this.message('银行卡所在国家不能为空', "The bank country can't be null");
        return false
      } else if (!param.swiftCode) {
        this.message('Swift Code不能为空', "The Swift Code can't be null");
        return false
      }
    } else if(!param.bankDetail){
      // if (this.$i18n.locale == 'zh-cn') {
      //   this.$message.error('银行支行名称不能为空')
      // }else{
      //   this.$message.error("The bank branch can't be null")
      // }
    }
      api.bindBankInfo(param).then(res => res.data).then(data => {
        this.$message.success(data.msg)
        this.getMemberInfo()
        this.cancel(type)
      })
    },
    message(cnMsg, enMsg) {
      if (this.$i18n.locale == 'zh-cn') {
        this.$message.error(cnMsg)
      }else{
        this.$message.error(enMsg)
      }
    },
    getArea(type, refcd) {
      let param = '';
      switch (type) {
        case 'provice': param = 'SINO_GEOGR_1';
        break;
        case 'city': param = 'SINO_GEOGR_2';
        break;
        case 'area': param = 'SINO_GEOGR_3';
        break;
        default: param = 'SINO_GEOGR_1';
      }
      return new Promise((resolve, reject) => {
        api.getArea({ refgrp: param, refcd: refcd}).then(res => res.data).then(data => {
          let optionList = data.data;
          if(type === 'provice') {
            this.options = optionList
          } else if(type === 'city') {
            this.cityOptions = optionList
          } else {
            this.areaOptions = optionList
          }
          resolve();
        })
      })
    },
    change(value,type) {
      this.addressFormData[type] = value
      let code = ''
      if (type == 'provice') {
        this.addressFormData.city = ''
        this.addressFormData.area = ''
        this.cityOptions = []
        this.areaOptions = []
        code = this.valueToCode(this.options, value);
        this.getArea('city', code);
      } else if (type == 'city') {
        this.addressFormData.area = ''
        this.areaOptions = []
        code = this.valueToCode(this.cityOptions, value);
        this.getArea('area', code);
      }
    },
    personCenterInfo() {
      api.personCenterInfo({language: "CHINAESE"}).then(res => res.data).then(data => {
        this.personInfo = data.data
        this.personInfo.sexName =  this.personInfo.sex=='M' ? this.$t('Modals[20]') : this.$t('Modals[19]');
        this.addressFormData = JSON.parse(JSON.stringify(this.personInfo))
      })
    },
    uploadFile(event){
      let file = event.target.files[0]
      let type = file.type.split('/')[0];
      if ( type === 'image' ){
        // 文件类型 1 身份证正面照片 2 身份证反面 3 护照
        // types.push(this.personInfo.idType)
        let files = []
        files.push(file)

        let types = []
        types.push(3)
        let formData = new FormData();
        formData.append("files", files)
        formData.append("types", types)
        api.uploadIdCardInfo(formData).then(res => res.data).then(data => {
          console.log(data)
        })
      }else{
        alert('只能上传图片');
      }
    },
    getMemberInfo() {
      api.getMemberInfo().then(res => res.data).then(data => {
        let cardList = data.data
        this.BXcardList = data.data.map(item=>{
          item.isShowBankListTable=false
          item.isAddCard=false
          this.fetchBankInfo(item.ylMemberNo)
          return item
        })
      })
    },
    fetchBankInfo(memberNo){
      api.bankCardInfo({ memberNo: memberNo }).then(res => res.data).then(data => {
        this.BXcardList.filter(item=>item.ylMemberNo==memberNo)[0].bankList=data.data
          // return data.data
        })
    },
    handleChangeID(type,info) {
      if(type=='1'){
        if (info.file.status === 'uploading') {
          this.loading = true;
          return;
        }
        if(info.file.status === 'done'){
          getBase64n(info.file.originFileObj, imageUrl => {
            this.imageUrl = imageUrl;
            this.loading = false;
          });
        }
      }else if(type=='2'){
        if (info.file.status === 'uploading') {
          this.loading1 = true;
          return;
        }
        if(info.file.status === 'done'){
          getBase64n(info.file.originFileObj, imageUrl => {
            this.imageUrl1 = imageUrl;
            this.loading1 = false;
          });
        }
      }else if(type=='3'){
        if (info.file.status === 'uploading') {
          this.loading2 = true;
          return;
        }
        if(info.file.status === 'done'){
          getBase64n(info.file.originFileObj, imageUrl => {
            this.imageUrl2 = imageUrl;
            this.loading2 = false;
          });
        }
      }
      let files=[]
      files.push(info)
      const formData = new FormData();
      formData.append('file', files);
      formData.append("types", type)
      let data={types:type,files:formData}
      // api.uploadIdCard(formData).then(res=>{
      //   debugger
      //   if(res.data.returnCode==='00'){
          
      //   }
      // })
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      return isJpgOrPng;
    },
    uploadPhoto(e,type) {
      // 利用fileReader对象获取file
      var file = e.target.files[0]
      var filename = file.name
      let itemFile={
        type:type,file:file,filename:filename
      }
      if(this.cardFileList.length==0 || this.cardFileList.filter(item=>item.type==type).length==0){
        this.cardFileList.push(itemFile)
      }else{
        this.cardFileList.filter(item=>item.type==type)[0]=itemFile
      }
      if(e.target.files[0]){
          var imageUrl = URL.createObjectURL(e.target.files[0]);
          if(type=='1'){
            this.imgUrl=imageUrl
          }else if(type=='2'){
            this.imgUrl1=imageUrl
          }else if(type=='3'){
            this.imgUrl2=imageUrl
          }else if(type=='081'){
            this.imgUrl3=imageUrl
          }else{
            this.imgUrl4=imageUrl
          }
        }
    },
    submitPhoto(){
      var files=[]
      var types=[]
      const formData = new FormData();
      debugger
      if(this.uploadType=='00'){
        if(this.cardFileList.filter(item=>item.type=='1').length>0&&this.cardFileList.filter(item=>item.type=='2').length>0){
          formData.append('files', this.cardFileList.filter(item=>item.type=='1')[0].file,this.cardFileList.filter(item=>item.type=='1')[0].filename);
          formData.append('files', this.cardFileList.filter(item=>item.type=='2')[0].file,this.cardFileList.filter(item=>item.type=='2')[0].filename);
          formData.append('types', this.cardFileList.filter(item=>item.type=='1')[0].type);
          formData.append('types', this.cardFileList.filter(item=>item.type=='2')[0].type);
        }else if(this.cardFileList.filter(item=>item.type=='1').length==0){
          this.$message.error(this.$t('cardUpload.upload1p'));
          return false
        }else if(this.cardFileList.filter(item=>item.type=='2').length==0){
          this.$message.error(this.$t('cardUpload.upload2p'));
          return false
        }else{
          this.$message.error(this.$t('cardUpload.upload1p'));
          this.$message.error(this.$t('cardUpload.upload2p'));
          return false
        }
      }else if(this.uploadType=='01'){
        if(this.cardFileList.filter(item=>item.type=='3').length==0){
          this.$message.error(this.$t('cardUpload.upload3p'));
          return false
        }else{
          formData.append('files', this.cardFileList.filter(item=>item.type=='3')[0].file,this.cardFileList.filter(item=>item.type=='3')[0].filename);
          formData.append('types', this.cardFileList.filter(item=>item.type=='3')[0].type);
        }
      }else if(this.uploadType=='08'){
        if(this.cardFileList.filter(item=>item.type=='081').length==0&&this.cardFileList.filter(item=>item.type=='082').length==0){
          this.$message.error(this.$t('cardUpload.upload4p'));
          return false
        }else{
          if(this.cardFileList.filter(item=>item.type=='081').length>0){
            formData.append('files', this.cardFileList.filter(item=>item.type=='081')[0].file,this.cardFileList.filter(item=>item.type=='081')[0].filename);
            formData.append('types', '08');
          }
          if(this.cardFileList.filter(item=>item.type=='082').length>0){
            formData.append('files', this.cardFileList.filter(item=>item.type=='082')[0].file,this.cardFileList.filter(item=>item.type=='082')[0].filename);
            formData.append('types', '08');
          }
        }
      }
      api.uploadIdCard(formData).then(res=>{
        if(res.data.code==='200'){
          this.personCenterInfo()
          this.uploadTag=false
        }
      })
    },
    userDateChange(date,dateString){
      this.userDate=dateString
    },
    disabledDate(currentDate) {
      let minDate=moment()
      return (
        currentDate && (currentDate < minDate)
      );
    },
    ifLongChange(e) {
      console.log('选择了长期',e)
      this.ifLong = e.target.checked
    },
    submitInfo(){
      if(!this.userName){
        this.$message.error(this.$t('alertPrompt[23]'));
        return
      }else if(!this.userIdCardNumber){
        this.$message.error(this.$t('alertPrompt[28]'));
        return 
      }else if(this.ifLong==false&&!this.userDate){
        this.$message.error(this.$t('alertPrompt[29]'));
        return
      }
      let postData={
        idNumber:this.userIdCardNumber,
        name:this.userName,
        validDate:this.ifLong==false?this.userDate:'9999-12-31',
        mobile:this.personInfo.phone,
        sex:this.personInfo.sex,
        idType:this.userIdType
      }
      api.uploadInfoByForm(postData).then(res => res.data).then(data => {
        if(data.code=='200'){
          this.$message.success(data.msg);
        }else{
          this.$message.error(data.msg);
        }
        this.personCenterInfo()
        this.uploadTag=false
      })
    },
    changeCurrency(val){
      this.formData.currency=val
    }
  },
}
</script>
<style lang="scss" scoped>
  .page_ {
    color: #394155;
    width: 100%;
    .ml10 {
      margin-left: 10px;
    }
    .tit_ {
      padding-right: 29px;
      display: flex;
      // justify-content: space-between;
      font-size: 16px;
      margin-bottom: 16px;
      align-items:center;
      align-content: center;
      img.modify_{
        width:16px;
        height:16px;
      }
      .modify_ {
        color: #2C5ACC;
        font-size:14px;
        margin-left: 10px;
      }
    }
    .fw_ {
      font-weight: bold;
      position:relative;
      // &::before{
      //   content:'';
      //   display:block;
      //   position:absolute;
      //   left:-10px;
      //   top:0;
      //   bottom:0;
      //   height:15px;
      //   width:2px;
      //   margin:auto 0;
      //   border-radius:2px;
      //   background-color:#2C5ACC;
      // }
    }
    .mr_ {
      margin-right: 30px;
      &.gray_{
        color:#ccc;
      }
    }
    .notice_ {
      background-color: #fff;
      width: 100%;
      // height: 110px;
      border-radius: 10px;
      padding: 27px 0 27px 29px;
      margin-bottom: 20px;
    }
    .card_ {
      width: 100%;
      // height: 560px;
      border-radius: 10px;
      background-color: #fff;
      padding: 27px 29px  29px;
      .account_ {
        margin-top: 16px;
        margin-bottom: 17px;
        position: relative;
        padding-left: 16px;
        .fw_{
          &::before{
            display:none;
          }
        }
          .arrow_ {
                &::after {
                  content: '';
                  display: block;
                  height: 0;
                  width: 0;
                  position: absolute;
                  top: 0;
                  bottom:0;
                  margin:auto 0;
                  left: 0;
                  border: 5px solid;
                  border-color: transparent transparent transparent #2C5ACC;
                }
                &.right_::after {
                  top: 5px;
                }
            }
            .arrow_t {
               &::after {
                  content: '';
                  display: block;
                  height: 0;
                  width: 0;
                  position: absolute;
                  top: 7px;
                  left: 0px;
                  border: 5px solid;
                  border-color: #2C5ACC transparent transparent transparent;
                }
            }
        // }
      }
      .add_ {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .foot_ {
        margin-top: 20px;
        padding-top: 17px;
        border-top: 1px #E7E7E7 solid;
        position: relative;
        .ld_arrow_ {
        &::after {
                  content: '';
                  display: block;
                  height: 0;
                  width: 0;
                  position: absolute;
                  top: 20px;
                  left: 0;
                  border: 5px solid;
                  border-color: transparent transparent transparent #2C5ACC;
                }
                &.right_::after {
                  top: 5px;
                //   border-color: transparent #4d4d4d transparent transparent;
                }
        }
        .ld_arrow_t {
          &::after {
                  content: '';
                  display: block;
                  height: 0;
                  width: 0;
                  position: absolute;
                  top: 23px;
                  left: 0;
                  border: 5px solid;
                  border-color: #2C5ACC transparent transparent transparent;
                }
        }
      }
      .card_info {
        margin-right: 22px;
        &.bold_{
          font-weight:bold;
        }
      }
      .card_1 {
        color: #2C5ACC;
        margin-top: 20px;
        width: auto;
        height: 30px;
        display:inline-block;
        padding:0 10px;
        line-height: 30px;
        border-left: 3px #2C5ACC solid;
        background: #FAFAFA;
        text-align: center;
        margin-bottom: 20px;
        font-weight: 500;
      }
      .modify_info {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item {
          width:32%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 20px;
        }
        .mr_ {
          margin-right: 8px;
          width:80px;
          min-width:70px;
          white-space: nowrap;
        }
        &.long{
          .mr_{
            width:120px;
            min-width:120px;
          }
        }
      }
    }
    .long_time_ {
      // border: 1px solid #eee;
      display: inline-block;
      border-left: 0;
      height: 31px;
      line-height: 30px;
      // margin-left: -50px;
    }
  }
  .blue_f{
    color:#2C5ACC;
    font-size:13px;
    font-weight:bold;
  }
  .blue_c{
    color:#2C5ACC
  }
  .icon_info{
    width:18px;
    height:18px;
    display:inline-block;
    background:url(../assets/medilinkPC/info1.png) center center no-repeat;
    background-size:18px 18px;
    min-width:18px;
    margin-right:5px;
  }
  .item_bank:last-child{
    border-bottom:none!important;
  }
  .del_btn:hover{
    color:#E5002D!important;
    font-weight:bold;
  }
  .hover_bold:hover{
    font-weight:bold;
  }
  .upload_{
    display:flex;
    margin-top:20px;
    justify-content: space-between;
    width:400px;
    margin:20px auto 0;
    .upload_c{
      width: 150px;
      position:relative;
      margin-right:30px;
      img{
        width: 150px;
        height: 150px;
      }
      input{
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        left:0;
      }
      span{
        display:block;
        text-align:center;
        padding:10px 0;
      }
    }
  }
  .flex_f{
    display:flex;
    flex-wrap:wrap;
    .info_item{
      width:48%;
      margin-right:4%;
      position:relative;
      display:flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom:20px;
      &:nth-child(2n+2){
        margin-right:0;
      }
      label{
        width:70px;
        display:inline-block;
        white-space: nowrap;
      }
      span{
        width:20%;
        display:inline-block;
        background-color:#2C5ACC;
        color:#fff;
        border-radius:2px;
        text-align:center;
        margin-left:5px;
        height:31px;
        line-height:31px;
        cursor:pointer;
      }
    }
    &.long{
      .info_item{
        label{
          width:140px;
        }
      }
    }
  }
  .item_u{
    display:flex;
    margin-bottom:15px;
    label{
      width:100px;
      display:inline-block;
    }
  }

</style>
